import React, { useEffect, useMemo, useState } from "react";
import config, { getConfig } from "../../../../../network/auth";
import axios from "../../../../../network/api";
import { Spinner } from "react-bootstrap";
import './categoryScreen.css';
import { baseUrl } from "../../../../../network/constants/constants";
import CategoryTable from "../categoryComponent/categoryComponent";
import CategoryForm from "../categoryComponent/categoryForm";
import { Snackbar, Alert } from "@mui/material";
import AppConstants from "../../../../AppConstants";

export const CategoryScreen = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
  


  const config = useMemo(() => {
    return getConfig()
  },[])
const bID = localStorage.getItem(AppConstants.business_id);

  const fetchCategories = () => {
    setLoading(true);
    axios
      .get(baseUrl + `businessadmin/categories-by-business/${bID}`, config)
      .then((response) => {
        setCategories(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Categories Error:", error);
        setLoading(false);
      
      });
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleShowModal = (category = null) => {
    setSelectedCategory(category);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedCategory(null);
  };

  const handleFormSubmit = (formData) => {
    const isEditing = Boolean(selectedCategory);
    const url = isEditing
      ? `${baseUrl}businessadmin/categories-edit-request/${selectedCategory.id}/`
      : `${baseUrl}app/category/create/`;
  
    const method = "post";
  
    const form = new FormData();
  
    if (isEditing) {
      
      form.append("new_category_name", formData.category_name);
      form.append("is_home_listed", formData.is_home_listed);
      form.append("business", bID);
      if (formData.icon) form.append("new_icon", formData.icon); 
    } else {
      
      form.append("category_name", formData.category_name);
      form.append("is_home_listed", formData.is_home_listed);
      form.append("business", bID);
      if (formData.icon) form.append("icon", formData.icon); 
    }
  
    axios({
      method,
      url,
      data: form,
      headers: { ...config.headers, "Content-Type": "multipart/form-data" },
    })
      .then((response) => {
        fetchCategories();
        handleCloseModal();
        setSnackbar({ open: true, message: response.data.message, severity: "success" });
      })
      .catch((error) => {
        console.error("Error saving category:", error);
        setSnackbar({ open: true, message: "Failed to save category", severity: "error" });
      });
  };
  

  const deleteCategory = (categoryId) => {
    setLoading(true);
  
    axios
      .delete(`${baseUrl}app/category/edit-or-delete/${categoryId}/`, config)
      .then((response) => {
        fetchCategories();
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error deleting category:", error);
        setLoading(false);
        
      });
  };
  
  



  return (
    <div className="category-container">
      <button className="btn-add" onClick={() => handleShowModal()}>+ Add Category</button>
      {loading ? (
        <div className="loader-container">
          <Spinner className='spinner-loader' />
        </div>
      ) : (
        <div>
          <CategoryTable categories={categories} loading={loading} onEdit={handleShowModal} onDelete={deleteCategory} />
        </div>
      )}
      <CategoryForm
        show={showModal}
        handleClose={handleCloseModal}
        handleSubmit={handleFormSubmit}
        category={selectedCategory}
      />
       <Snackbar open={snackbar.open} autoHideDuration={6000} onClose={() => setSnackbar({ ...snackbar, open: false })} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
     
    </div>
  );
};

export default CategoryScreen;
